export default function useStringMethods() {

    const cutStringByWords = (text, wordslen) => {

        if (wordCount(text) <= wordslen) {
            return text;
        } else {
            const words = text.split(' ');
            return words.slice(0, wordslen).join(' ') + '...';
        }
    }

    //belongs to handling the picture
    const wordCount = (text)=>{
        const words = text.split(' ');
        return words.length
    }

    return {
        cutStringByWords,
        wordCount
    }
}
